@if (viewModel) {
    <div class="betslip-result-summary-table">
        @if (rewardsUsedRows.length > 0) {
            <div>{{ rewardTitle }}</div>
            <div class="reward-token-badge-container">
                @for (rewardsUsed of rewardsUsedRows; track $index) {
                    <div class="reward-token-badge-container__row">
                        @for (badge of rewardsUsed; track $index) {
                            <div>
                                <bs-reward-used-badge [badge]="badge" />
                            </div>
                        }
                    </div>
                }
            </div>
        }
        @if (viewModel.numberOfBets && !isQuickBetConfirmation) {
            <span>{{ viewModel.numberOfBets.title }}</span>
            <span [msAutomation]="'betslip-result-summary__number-of-bets'">{{ viewModel.numberOfBets.value }}</span>
        }
        <span>{{ viewModel.stake.title }}</span>
        <span [msAutomation]="'betslip-result-summary__stake'">{{ viewModel.stake.value | bsCurrency: true }}</span>
        @if (viewModel.odds && !isTeaserBet) {
            <span>{{ viewModel.odds.title }}</span>
            <span>
                <bs-result-odds [odds]="viewModel.odds.value" [boostedOdds]="viewModel.odds.boosted" [oddsDisplayFormat]="oddsDisplayFormat" />
            </span>
        }
        <span [msAutomation]="'betslip-result-summary__possible-winnings'">
            {{ viewModel.possibleWinnings.title }}
            @if (viewModel.taxation || isTurnOverTax) {
                <span class="theme-info betslip-summary__wins__info-icon" (click)="displayTaxationInfo()"></span>
            }
        </span>
        <span>
            <span
                [class.betslip-result-original-winnings]="!!viewModel.possibleWinnings.boostedValue"
                [msAutomation]="'betslip-result-summary__wins'"
                >{{ viewModel.isPotentailReturn ? siteCore.betslip.messages.NA : (viewModel.possibleWinnings.value | bsCurrency: true) }}</span
            >
            @if (viewModel.possibleWinnings.boostedValue) {
                <span [msAutomation]="'betslip-result-summary__boosted-wins'">{{ viewModel.possibleWinnings.boostedValue | bsCurrency: true }}</span>
            }
        </span>
        @if (isTurnOverTax && turnOverTaxationMessage) {
            <div class="result-summary-tax-info">
                <span>{{ turnOverTaxationMessage }}</span>
            </div>
        }
        @for (payoutSummary of viewModel.tokenPayoutSummaries; track $index) {
            <bs-token-payout-summary class="betslip-result-summary__token-payout-summary" [tokenPayoutSummary]="payoutSummary" />
        }
    </div>
    @if (isStakeLimitsInfoDisplayed) {
        <bs-user-stake-limits />
    }
    <bs-digital-taxation-info [vm]="buildTaxationPopupViewModel()" [(isVisible)]="isTaxationInfoVisible" />
}
